import { API_HOST, getHttpPostOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/poll`;

export const getCreatePollRequest = (poll) => [getEndpoint(), getHttpPostOptions(poll)];

export const getUpdatePollRequest = (poll) => [getEndpoint(), getHttpPutOptions(poll)];

const getViewPollResultsEndpoint = (programmeExternalReference, pollExternalReference) =>
  `${getEndpoint()}/result/${programmeExternalReference}/${pollExternalReference}`;
export const getViewPollResultsRequest = (programmeExternalReference, pollExternalReference) => [
  getViewPollResultsEndpoint(programmeExternalReference, pollExternalReference),
  getHttpPostOptions()
];
